/* src/app/layout/components/routemagic-assistant/client-portal-routemagic-assistant/client-portal-routemagic-assistant.component.scss */
.chat-container {
  --chat-button-color: var(--orange);
  --chat-header-bg-color: var(--orange);
}
.chat-container .iframe-container {
  position: relative;
  right: 0px;
  top: 10px;
  z-index: 5;
  height: 100%;
}
.chat-container .iframe-container iframe {
  display: none;
}
.chat-container .customer-chat {
  position: fixed;
  right: 0px;
  bottom: 50px;
  z-index: 6;
  background: #fff;
}
.chat-container .acOpenButton {
  color: white;
  background-color: var(--chat-button-color);
  position: fixed;
  bottom: 20px;
  right: 10px;
}
.chat-container .acCloseButton {
  color: white;
  background-color: var(--chat-button-color);
  display: none;
  position: fixed;
  bottom: 20px;
  right: 10px;
}
.chat-container .acButtonStyles {
  width: 55px;
  height: 55px;
  border-radius: 50%;
  border: none;
  float: right;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
  outline: none;
  cursor: pointer;
  transition: background-color 0.5s ease;
  z-index: 10;
}
.chat-container .hide {
  display: none !important;
}
.chat-container .show {
  display: inline !important;
}
/*# sourceMappingURL=data:application/json;base64,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 */
